import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import ReportLauncherTemplate from "../compiled-templates/ReportLauncherTemplate";
import * as trans from "../common/Translator";
import * as ts from "../common/Translator";
import * as OutputFormat from "../constants/OutputFormat";
import {currentUserSettings} from "../login/LoginPresenter";
import {NamaKendoWindow, NamaWindowBtnData} from "./NamaKendoWindow";
import {getCustomGUISettings} from "../login/ClientCache";

export class ReportLauncherView {
    /**
     *
     * @param {ReportLauncherPresenter} presenter
     */
    constructor(presenter) {
        this.presenter = presenter;
    }

    render() {
        let that = this;
        that.container = $(ReportLauncherTemplate({title: trans.isArabic() ? that.presenter.reportRef.name1 : that.presenter.reportRef.name2}));
        that.rootElement = that.container.find("#pageTabs");
        let questionFieldsEditor = new QuestionFieldsEditor(that.entityType);
        that.presenter.metaData = {fieldsMetaData: [...that.presenter.reportMetaData.questionFields.map(qField => qField.metaData)]};
        questionFieldsEditor.edit(that.presenter.reportMetaData.questionFields, that.presenter.defaultParameterValues(), null, null, that.presenter, that, that.presenter);
        that.presenter.questionFieldsEditor = questionFieldsEditor;
        let actionsContainer = $(`<li class="k-state-active"><div id="actionButtons" class="simple-row clearfix"></div></li>`);
        let runReportBtn = $(`<button id="runReport" style="margin-left: 10px;">${ts.translateId("runReport")}</button>`);
        runReportBtn.kendoButton({
            click: (e) => {
                e.event.stopPropagation();
                that.questionFields = questionFieldsEditor.getQuestionFields();
                that.presenter.onClick(true, formatList.data("kendoDropDownList").value())
            }
        });
        let runReportInsideWindowBtn = $(`<button id="runReportInsideWindow" style="margin-left: 10px;">${ts.translateId("runReportInsideWindow")}</button>`);
        runReportInsideWindowBtn.kendoButton({
            click: (e) => {
                e.event.stopPropagation();
                that.questionFields = questionFieldsEditor.getQuestionFields();
                that.presenter.onClick(false, formatList.data("kendoDropDownList").value())
            }

        });
        let formatList = $(`<input id = "formatList" style="margin: 10px;"/>`);
        let reportDetails = $(`<a href="#" id="reportDetails" style="margin: 10px;" class="k-icon k-i-info"></a>`);
        reportDetails.on("click", ((e) => {
            e.preventDefault();
            e.stopPropagation();
            that.showReportDetails();
        }));
        actionsContainer.append(reportDetails);
        actionsContainer.append(formatList);
        actionsContainer.append(runReportBtn);
        actionsContainer.append(runReportInsideWindowBtn);
        actionsContainer.appendTo(that.rootElement);
        let viewFormat = that.presenter.reportMetaData.viewingFormat || currentUserSettings().viewingFormat || getCustomGUISettings().tooltipsAndReportsAndRevise.globalConfigReportsViewingFormat || OutputFormat.HTML;
        formatList.kendoDropDownList({
            value: viewFormat,
            dataSource: [OutputFormat.HTML, OutputFormat.PDF],
            change: function (e) {
                that.presenter.place.format = this.value() || OutputFormat.HTML;
            }
        });
        return that.container;
    }

    addDataWidget(widget) {
    }

    showReportDetails() {
        let that = this;
        let window = new NamaKendoWindow("reportDetails", new NamaWindowBtnData("ok", () => window.closeWindow()), new NamaWindowBtnData("cancel"));
        let repDetails = $(`<Label id = "repDetails"></Label>`);
        let reportDetails = that.presenter.reportMetaData.reportDetails;
        if (!reportDetails)
            reportDetails = ts.translateId("noReportDetails");
        repDetails.text(reportDetails);
        window.addDataWidget(repDetails);
        window.showWindow();
    }
}